{
  "name": "Forcefield Button",
  "powerupName": "Barrier",
  "levelUpDescriptions": [
    "BarrierDescription1",
    "BarrierDescription2",
    "BarrierDescription3",
    "BarrierDescription4",
    "BarrierDescription5"
  ]
}